<div class="d-flex flex-column flex-root h-100" id="kt_login_wrapper">
  <div class="login login-1 login-signin-on d-flex flex-column flex-lg-row flex-column-fluid bg-white" id="kt_login">
    <div class="login-aside d-flex flex-column flex-row-auto" style="background-image: url('./assets/media/login-image/iowa.jpg'); background-size: 100% 100%; ">
    </div>
    <div class="login-content flex-row-fluid d-flex flex-column justify-content-center position-relative overflow-hidden p-7 mx-auto">
      <div id="kt_header" class="header" >
        <div class="container-fluid d-flex align-items-stretch justify-content-between">
          <div class="header-menu-wrapper header-menu-wrapper-left" id="kt_header_menu_wrapper">
            <div class="header-logo mt-3" style="text-align:left!important;">
              <a href="#" onClick="return false;" style="display:none;">
                <img alt="Logo" src="assets/media/logo/dhslogocolor350.png" />
              </a>
            </div>
          </div>
        </div>
      </div>
      <div class="d-flex flex-column-fluid flex-center mb-10" >
        <router-outlet></router-outlet>
      </div>
      <div class="d-flex justify-content-lg-start justify-content-center align-items-end py-7 py-lg-0">
        <span class="font-weight-bolder">© {{currentYear}} Iowa Department of Human Services</span>
        <a href="https://www.iowa.gov/policies/disclaimer" target="_blank" class="text-primary ml-2 font-weight-bolder font-size-h6">Privacy</a>
      </div>
    </div>
  </div>
</div>
